import { render, staticRenderFns } from "./admin_articles_by_milestone_strategy.vue?vue&type=template&id=5cbbd0e6&scoped=true"
import script from "./admin_articles_by_milestone_strategy.vue?vue&type=script&lang=js"
export * from "./admin_articles_by_milestone_strategy.vue?vue&type=script&lang=js"
import style0 from "./admin_articles_by_milestone_strategy.vue?vue&type=style&index=0&id=5cbbd0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbd0e6",
  null
  
)

export default component.exports